/* eslint-disable @typescript-eslint/no-explicit-any */
import { SanityBlock } from '@/types/sanity.types';
import React from 'react';

type SanityBlockContentProps = {
  Tag?: string | typeof React.Fragment;
  content?: SanityBlock[];
  cssClasses?: string | Record<string, string>;
  styles?: Record<string, string>;
};

export const sanityRenderBlockContent = ({ Tag, content, cssClasses, styles }: SanityBlockContentProps) =>
  content?.map(({ children, style }) => {
    const Element = Tag ?? style !== 'normal' ? style : 'p';

    return (
      <Element
        key={children?.[0].text}
        {...(Tag === React.Fragment
          ? undefined
          : {
              className: typeof cssClasses === 'string' ? cssClasses : cssClasses?.[Element] || undefined,
              style: styles,
            })}
      >
        {children.map((child: any, index: number) => (
          <React.Fragment key={index}>{child?.text}</React.Fragment>
        ))}
      </Element>
    );
  });
